export function getTarget(target?: string | null): string {
  return target && target.length ? target : '_self';
}

/** Strip tags and decode HTML entities from a RichText-stored value. */
export function plainText(html: string | undefined): string {
  if (!html) return '';
  if (typeof window !== 'undefined' && typeof window.DOMParser !== 'undefined') {
    return new window.DOMParser().parseFromString(html, 'text/html').body.textContent?.trim() ?? '';
  }
  return html.replace(/<[^>]+>/g, '').trim();
}

export const getRel = (target?: string | null) =>
  target === '_blank' ? 'noopener noreferrer' : undefined;
